import { ReactNode } from 'react';
import { Tag } from '@uigovpe/components';

/** Valor vindo do login gov.br: o valor primeiro, com o selo "Via gov.br" depois. */
export function GovBrValue({ value }: { value: ReactNode }) {
  return (
    <span className="cd-govbr-value">
      {value}
      <Tag value="Via gov.br" severity="info" />
    </span>
  );
}
